<base-site-layout
  [heading]="'Lieferant auswählen' | translate"
  headerIcon="fas fa-truck"
  [isDialog]="true"
  (dialogCloseClicked)="cancel()"
  >
  <div class="row">
    <div class="col-12 col-lg-6">
      @if (step() === 'supplier') {
        <div class="row">
          <div class="col">
            <div class="alert alert-info" role="alert" data-testid="pdf-supplier-selection-hint">
              @if (data.detectedSupplierName) {
                {{ 'Der im Dokument erkannte Lieferant "\{\{name\}\}" ist nicht eindeutig. Bitte wählen Sie den passenden Lieferanten aus.' | translate: { name: data.detectedSupplierName } }}
              } @else {
                {{ 'Der Lieferant konnte nicht eindeutig erkannt werden. Bitte wählen Sie den passenden Lieferanten aus.' | translate }}
              }
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col d-flex flex-column">
            <label for="pdf-supplier-search">{{ 'Alle Lieferanten durchsuchen' | translate }}</label>
            <div class="input-group">
              <span class="input-group-text"><em class="fas fa-magnifying-glass"></em></span>
              <input
                id="pdf-supplier-search"
                type="text"
                class="form-control"
                data-testid="pdf-supplier-search"
                [formControl]="searchControl"
                [placeholder]="'Lieferantenname eingeben' | translate"
                />
            </div>
          </div>
        </div>
        @if (searchRunning()) {
          <div class="row mt-3">
            <div class="col text-center">
              <em class="fas fa-spinner fa-spin pe-2"></em>
              {{ 'Lieferanten werden gesucht' | translate }}
            </div>
          </div>
        } @else if (searchResults(); as results) {
          <div class="row mt-3">
            <div class="col">
              <label class="fw-bold">{{ 'Suchergebnisse' | translate }}</label>
              @if (results.length === 0) {
                <div class="alert alert-info mb-0">
                  {{ 'Keine Lieferanten gefunden' | translate }}
                </div>
              } @else {
                <ul class="list-group search-result-list" data-cy="PDF_SUPPLIER_SEARCH_RESULTS">
                  @for (supplier of results; track supplier.id) {
                    <li
                      class="list-group-item hoverable cursor-pointer"
                      [class.active]="isSelected(supplier)"
                      (click)="selectSupplier(supplier)"
                      (keydown.enter)="selectSupplier(supplier)"
                      tabindex="0"
                      >
                      <ng-container
                        *ngTemplateOutlet="supplierEntry; context: { $implicit: supplier }"
                      ></ng-container>
                    </li>
                  }
                </ul>
              }
            </div>
          </div>
        } @else if (data.candidates.length > 0) {
          <div class="row mt-3">
            <div class="col">
              <label class="fw-bold">{{ 'Vorschläge' | translate }}</label>
              <ul class="list-group mb-3" data-cy="PDF_SUPPLIER_CANDIDATES">
                @for (candidate of data.candidates; track candidate.id) {
                  <li
                    class="list-group-item hoverable cursor-pointer"
                    [class.active]="isSelected(candidate)"
                    (click)="selectSupplier(candidate)"
                    (keydown.enter)="selectSupplier(candidate)"
                    tabindex="0"
                    >
                    <ng-container
                      *ngTemplateOutlet="supplierEntry; context: { $implicit: candidate }"
                    ></ng-container>
                  </li>
                }
              </ul>
            </div>
          </div>
        }
        <div class="row justify-content-end mt-4">
          <div class="col-auto">
            <button type="button" class="btn btn-outline-dark" (click)="cancel()">
              {{ 'Abbrechen' | translate }}
            </button>
          </div>
          <div class="col-auto">
            <button
              type="button"
              class="btn btn-primary"
              data-testid="pdf-supplier-next-button"
              (click)="proceedToContactSelection()"
              [disabled]="!selectedSupplier()"
              >
              {{ 'Weiter' | translate }}
            </button>
          </div>
        </div>
      } @else {
        <div class="row mb-2">
          <div class="col">
            @if (selectedSupplier(); as supplier) {
              <strong>{{ supplier.displayName }}</strong>
              @if (supplier.name2) {
                <div class="supplier-entry-detail">{{ supplier.name2 }}</div>
              }
              @if (addressLine(supplier); as address) {
                <div class="supplier-entry-detail">{{ address }}</div>
              }
            }
          </div>
        </div>
        @if (contactsLoading()) {
          <div class="row mb-3">
            <div class="col text-center">
              <em class="fas fa-spinner fa-spin pe-2"></em>
              {{ 'Ansprechpartner werden geladen' | translate }}
            </div>
          </div>
        } @else if (contacts().length === 0) {
          <div class="row mb-3">
            <div class="col">
              <div class="alert alert-info mb-0">
                {{ 'Für diesen Lieferanten sind keine Ansprechpartner hinterlegt' | translate }}
              </div>
            </div>
          </div>
        } @else {
          @if (preselectedContactId()) {
            <div class="row mb-2">
              <div class="col">
                <div class="alert alert-info mb-0" data-testid="pdf-supplier-contact-preselected">
                  {{ 'Der im Dokument erkannte Ansprechpartner wurde vorausgewählt.' | translate }}
                </div>
              </div>
            </div>
          }
          <div class="row mb-3">
            <div class="col d-flex flex-column">
              <label for="pdf-supplier-contact-select">{{ 'Ansprechpartner' | translate }}</label>
              <select
                id="pdf-supplier-contact-select"
                class="form-select"
                data-testid="pdf-supplier-contact-select"
                [formControl]="contactControl"
                >
                <option value="">{{ 'Kein Ansprechpartner' | translate }}</option>
                @for (contact of contacts(); track contact.person.id) {
                  <option [value]="contact.person.id">
                    {{ contact.person | person | supplierContactName: contact.defaultContact }}
                  </option>
                }
              </select>
            </div>
          </div>
        }
        @if (createError()) {
          <div class="row mb-3">
            <div class="col">
              <div class="alert alert-danger mb-0" role="alert">
                {{ createError() | translate }}
              </div>
            </div>
          </div>
        }
        @if (isCreating()) {
          <div class="row mb-3">
            <div class="col">
              <div class="alert alert-info mb-0" role="alert" data-testid="pdf-supplier-creating">
                <em class="fas fa-spinner fa-spin me-2"></em>
                {{ 'Bedarfsmeldung wird erstellt – das kann bis zu einer Minute dauern.' | translate }}
              </div>
            </div>
          </div>
        }
        <div class="row justify-content-end mt-4">
          <div class="col-auto">
            <button type="button" class="btn btn-outline-dark" (click)="backToSupplierSelection()" [disabled]="isCreating()">
              {{ 'Zurück' | translate }}
            </button>
          </div>
          <div class="col-auto">
            <button
              type="button"
              class="btn btn-primary"
              data-testid="pdf-supplier-confirm-button"
              (click)="confirm()"
              [disabled]="confirmDisabled()"
              >
              {{ 'Bedarfsmeldung erstellen' | translate }}
            </button>
          </div>
        </div>
      }
    </div>
    <!-- One row of the candidate/search-result lists: name, optional second name line and the
         address, so two suppliers with the same company name stay distinguishable. -->
    <ng-template #supplierEntry let-supplier>
      <div class="fw-semibold">{{ supplier.displayName }}</div>
      @if (supplier.name2) {
        <div class="supplier-entry-detail">{{ supplier.name2 }}</div>
      }
      @if (addressLine(supplier); as address) {
        <div class="supplier-entry-detail">{{ address }}</div>
      }
    </ng-template>
    <div class="col-12 col-lg-6 mt-2" *showOnDesktop>
      <div class="pdf-sticky-wrapper dialog">
        <pdf-preview [files]="pdfFiles"></pdf-preview>
      </div>
    </div>
  </div>
</base-site-layout>
